// Thu Mar 27 06:04:36 GMT 2025

import * as models from "../crm-web-api-models"

export enum TaskProp {
	AssignedPool = 'assignedPool',
	AssignedPoolName = 'assignedPool.name',
	AssignedUser = 'assignedUser',
	Assignments = 'assignments',
	CreatedBy = 'createdBy',
	CreationTime = 'creationTime',
	Creator = 'creator',
	CustomerAssignedUser = 'customer.assignedUser',
	CustomerId = 'customer.id',
	CustomerInteractionLastSource = 'customer.interaction.lastSource',
	CustomerInteractionModificationTime = 'customer.interaction.modificationTime',
	CustomerInteractionOnlineStatus = 'customer.interaction.onlineStatus',
	CustomerPersonFirstName = 'customer.person.firstName',
	CustomerPersonLastName = 'customer.person.lastName',
	CustomerPersonPhone1Num = 'customer.person.phone1.num',
	CustomerPersonPhone2Num = 'customer.person.phone2.num',
	Description = 'description',
	DueDate = 'dueDate',
	FollowAssignmentByParent = 'followAssignmentByParent',
	Id = 'id',
	Medium = 'medium',
	ModificationTime = 'modificationTime',
	ModifiedBy = 'modifiedBy',
	OriginMedium = 'originMedium',
	Priority = 'priority',
	RelatedEntity = 'relatedEntity',
	RelatedEntity$simpleName = 'relatedEntity$simpleName',
	RelatedEntityId = 'relatedEntity.id',
	RootRouter = 'rootRouter',
	StartDate = 'startDate',
	Status = 'status',
	Subject = 'subject',
	TaskCategory = 'taskCategory',
	TaskCategoryLabel = 'taskCategory.label'
}

export type TaskPropAssignedPool = {
	[TaskProp.AssignedPool] : any /* Entity */
}
export type TaskPropAssignedPoolName = {
	[TaskProp.AssignedPoolName] : string | null
}
export type TaskPropAssignedUser = {
	[TaskProp.AssignedUser] : models.UserDto | null
}
export type TaskPropAssignments = {
	[TaskProp.Assignments] : models.TaskAssignmentDto | null
}
export type TaskPropCreatedBy = {
	[TaskProp.CreatedBy] : models.UserDto
}
export type TaskPropCreationTime = {
	[TaskProp.CreationTime] : number | null
}
export type TaskPropCreator = {
	[TaskProp.Creator] : any /* Entity */
}
export type TaskPropCustomerAssignedUser = {
	[TaskProp.CustomerAssignedUser] : models.UserDto | null
}
export type TaskPropCustomerId = {
	[TaskProp.CustomerId] : number | null
}
export type TaskPropCustomerInteractionLastSource = {
	[TaskProp.CustomerInteractionLastSource] : 'WEBSITE' | 'WEBSITE_LOGIN' | 'MT4_CLIENT' | 'SAS' | 'CRM' | 'EXACT_TARGET' | 'C_PATTERN' | 'WEBSITE_REGISTRATION' | 'MT5_CLIENT' | 'ANDROID' | 'IOS' | 'NA' | null
}
export type TaskPropCustomerInteractionModificationTime = {
	[TaskProp.CustomerInteractionModificationTime] : number | null
}
export type TaskPropCustomerInteractionOnlineStatus = {
	[TaskProp.CustomerInteractionOnlineStatus] : 'OFFLINE' | 'ONLINE' | null
}
export type TaskPropCustomerPersonFirstName = {
	[TaskProp.CustomerPersonFirstName] : string | null
}
export type TaskPropCustomerPersonLastName = {
	[TaskProp.CustomerPersonLastName] : string | null
}
export type TaskPropCustomerPersonPhone1Num = {
	[TaskProp.CustomerPersonPhone1Num] : string | null
}
export type TaskPropCustomerPersonPhone2Num = {
	[TaskProp.CustomerPersonPhone2Num] : string | null
}
export type TaskPropDescription = {
	[TaskProp.Description] : string | null
}
export type TaskPropDueDate = {
	[TaskProp.DueDate] : number | null
}
export type TaskPropFollowAssignmentByParent = {
	[TaskProp.FollowAssignmentByParent] : boolean | null
}
export type TaskPropId = {
	[TaskProp.Id] : number
}
export type TaskPropMedium = {
	[TaskProp.Medium] : 'INTERNAL' | 'MAIL' | 'PHONE' | 'LIVE_CHAT' | 'SMS' | 'MEETING' | 'ZENDESK' | 'APP_POPUP' | 'APP_PUSH' | 'RECORDING' | 'ZENDESK_CHAT' | null
}
export type TaskPropModificationTime = {
	[TaskProp.ModificationTime] : number | null
}
export type TaskPropModifiedBy = {
	[TaskProp.ModifiedBy] : models.UserDto | null
}
export type TaskPropOriginMedium = {
	[TaskProp.OriginMedium] : 'INTERNAL' | 'MAIL' | 'PHONE' | 'LIVE_CHAT' | 'SMS' | 'MEETING' | 'ZENDESK' | 'APP_POPUP' | 'APP_PUSH' | 'RECORDING' | 'ZENDESK_CHAT' | null
}
export type TaskPropPriority = {
	[TaskProp.Priority] : 'HIGH' | 'MEDIUM' | 'LOW' | null
}
export type TaskPropRelatedEntity = {
	[TaskProp.RelatedEntity] : { id: number; type: string; name: number; } | null
}
export type TaskPropRelatedEntity$simpleName = {
	[TaskProp.RelatedEntity$simpleName] : string | null
}
export type TaskPropRelatedEntityId = {
	[TaskProp.RelatedEntityId] : number | null
}
export type TaskPropRootRouter = {
	[TaskProp.RootRouter] : any /* Entity */
}
export type TaskPropStartDate = {
	[TaskProp.StartDate] : number | null
}
export type TaskPropStatus = {
	[TaskProp.Status] : 'NEW' | 'IN_PROGRESS' | 'REJECTED' | 'FAILED' | 'RESOLVED' | 'CLOSED' | 'CANCELED' | null
}
export type TaskPropSubject = {
	[TaskProp.Subject] : string | null
}
export type TaskPropTaskCategory = {
	[TaskProp.TaskCategory] : any /* Entity */
}
export type TaskPropTaskCategoryLabel = {
	[TaskProp.TaskCategoryLabel] : string | null
}


export type Task = 
	TaskPropAssignedPool & 
	TaskPropAssignedPoolName & 
	TaskPropAssignedUser & 
	TaskPropAssignments & 
	TaskPropCreatedBy & 
	TaskPropCreationTime & 
	TaskPropCreator & 
	TaskPropCustomerAssignedUser & 
	TaskPropCustomerId & 
	TaskPropCustomerInteractionLastSource & 
	TaskPropCustomerInteractionModificationTime & 
	TaskPropCustomerInteractionOnlineStatus & 
	TaskPropCustomerPersonFirstName & 
	TaskPropCustomerPersonLastName & 
	TaskPropCustomerPersonPhone1Num & 
	TaskPropCustomerPersonPhone2Num & 
	TaskPropDescription & 
	TaskPropDueDate & 
	TaskPropFollowAssignmentByParent & 
	TaskPropId & 
	TaskPropMedium & 
	TaskPropModificationTime & 
	TaskPropModifiedBy & 
	TaskPropOriginMedium & 
	TaskPropPriority & 
	TaskPropRelatedEntity & 
	TaskPropRelatedEntity$simpleName & 
	TaskPropRelatedEntityId & 
	TaskPropRootRouter & 
	TaskPropStartDate & 
	TaskPropStatus & 
	TaskPropSubject & 
	TaskPropTaskCategory & 
	TaskPropTaskCategoryLabel

export const TASK_PROPERTY_NAMES = Object.freeze([TaskProp.AssignedPool, TaskProp.AssignedPoolName, TaskProp.AssignedUser, TaskProp.Assignments, TaskProp.CreatedBy, TaskProp.CreationTime, TaskProp.Creator, TaskProp.CustomerAssignedUser, TaskProp.CustomerId, TaskProp.CustomerInteractionLastSource, TaskProp.CustomerInteractionModificationTime, TaskProp.CustomerInteractionOnlineStatus, TaskProp.CustomerPersonFirstName, TaskProp.CustomerPersonLastName, TaskProp.CustomerPersonPhone1Num, TaskProp.CustomerPersonPhone2Num, TaskProp.Description, TaskProp.DueDate, TaskProp.FollowAssignmentByParent, TaskProp.Id, TaskProp.Medium, TaskProp.ModificationTime, TaskProp.ModifiedBy, TaskProp.OriginMedium, TaskProp.Priority, TaskProp.RelatedEntity, TaskProp.RelatedEntity$simpleName, TaskProp.RelatedEntityId, TaskProp.RootRouter, TaskProp.StartDate, TaskProp.Status, TaskProp.Subject, TaskProp.TaskCategory, TaskProp.TaskCategoryLabel])

export type TaskTab = 
	TaskPropId & 
	TaskPropTaskCategoryLabel

export const TASK_TAB_PROPERTY_NAMES = Object.freeze([TaskProp.Id, TaskProp.TaskCategoryLabel])

export type TaskHistoryTab = 
	TaskPropId & 
	TaskPropTaskCategoryLabel

export const TASK_HISTORY_TAB_PROPERTY_NAMES = Object.freeze([TaskProp.Id, TaskProp.TaskCategoryLabel])

export type TaskAssign = 
	TaskPropAssignedUser & 
	TaskPropAssignedPool & 
	TaskPropRootRouter

export const TASK_ASSIGN_PROPERTY_NAMES = Object.freeze([TaskProp.AssignedUser, TaskProp.AssignedPool, TaskProp.RootRouter])

export type TaskAssignConfig = 
	TaskPropAssignedPoolName & 
	TaskPropAssignments & 
	TaskPropCustomerAssignedUser

export const TASK_ASSIGN_CONFIG_PROPERTY_NAMES = Object.freeze([TaskProp.AssignedPoolName, TaskProp.Assignments, TaskProp.CustomerAssignedUser])

export type TaskCreate = 
	TaskPropCustomerId & 
	TaskPropTaskCategory & 
	TaskPropPriority & 
	TaskPropSubject & 
	TaskPropOriginMedium & 
	TaskPropDueDate & 
	TaskPropDescription

export const TASK_CREATE_PROPERTY_NAMES = Object.freeze([TaskProp.CustomerId, TaskProp.TaskCategory, TaskProp.Priority, TaskProp.Subject, TaskProp.OriginMedium, TaskProp.DueDate, TaskProp.Description])

export type CallTaskCreate = 
	TaskPropCustomerId & 
	TaskPropTaskCategory & 
	TaskPropPriority & 
	TaskPropSubject & 
	TaskPropStartDate & 
	TaskPropDescription

export const CALL_TASK_CREATE_PROPERTY_NAMES = Object.freeze([TaskProp.CustomerId, TaskProp.TaskCategory, TaskProp.Priority, TaskProp.Subject, TaskProp.StartDate, TaskProp.Description])

export type TaskHeader = 
	TaskPropId & 
	TaskPropTaskCategoryLabel & 
	TaskPropStatus & 
	TaskPropMedium

export const TASK_HEADER_PROPERTY_NAMES = Object.freeze([TaskProp.Id, TaskProp.TaskCategoryLabel, TaskProp.Status, TaskProp.Medium])

export type TaskGeneral = 
	TaskPropId & 
	TaskPropCreationTime & 
	TaskPropCreatedBy & 
	TaskPropModificationTime & 
	TaskPropModifiedBy & 
	TaskPropCreator & 
	TaskPropCustomerId & 
	TaskPropCustomerPersonFirstName & 
	TaskPropCustomerPersonLastName & 
	TaskPropRelatedEntity & 
	TaskPropRelatedEntityId & 
	TaskPropRelatedEntity$simpleName & 
	TaskPropTaskCategoryLabel & 
	TaskPropAssignedUser & 
	TaskPropAssignedPoolName & 
	TaskPropOriginMedium

export const TASK_GENERAL_PROPERTY_NAMES = Object.freeze([TaskProp.Id, TaskProp.CreationTime, TaskProp.CreatedBy, TaskProp.ModificationTime, TaskProp.ModifiedBy, TaskProp.Creator, TaskProp.CustomerId, TaskProp.CustomerPersonFirstName, TaskProp.CustomerPersonLastName, TaskProp.RelatedEntity, TaskProp.RelatedEntityId, TaskProp.RelatedEntity$simpleName, TaskProp.TaskCategoryLabel, TaskProp.AssignedUser, TaskProp.AssignedPoolName, TaskProp.OriginMedium])

export type CallTaskGeneral = 
	TaskPropId & 
	TaskPropCreationTime & 
	TaskPropCreatedBy & 
	TaskPropModificationTime & 
	TaskPropModifiedBy & 
	TaskPropCreator & 
	TaskPropCustomerId & 
	TaskPropCustomerPersonFirstName & 
	TaskPropCustomerPersonLastName & 
	TaskPropRelatedEntity$simpleName & 
	TaskPropTaskCategoryLabel & 
	TaskPropAssignedUser & 
	TaskPropAssignedPoolName & 
	TaskPropMedium & 
	TaskPropCustomerPersonPhone1Num & 
	TaskPropCustomerPersonPhone2Num & 
	TaskPropCustomerInteractionModificationTime & 
	TaskPropCustomerInteractionLastSource & 
	TaskPropCustomerInteractionOnlineStatus & 
	TaskPropFollowAssignmentByParent

export const CALL_TASK_GENERAL_PROPERTY_NAMES = Object.freeze([TaskProp.Id, TaskProp.CreationTime, TaskProp.CreatedBy, TaskProp.ModificationTime, TaskProp.ModifiedBy, TaskProp.Creator, TaskProp.CustomerId, TaskProp.CustomerPersonFirstName, TaskProp.CustomerPersonLastName, TaskProp.RelatedEntity$simpleName, TaskProp.TaskCategoryLabel, TaskProp.AssignedUser, TaskProp.AssignedPoolName, TaskProp.Medium, TaskProp.CustomerPersonPhone1Num, TaskProp.CustomerPersonPhone2Num, TaskProp.CustomerInteractionModificationTime, TaskProp.CustomerInteractionLastSource, TaskProp.CustomerInteractionOnlineStatus, TaskProp.FollowAssignmentByParent])

export type TaskStatus = 
	TaskPropStatus & 
	TaskPropPriority & 
	TaskPropSubject & 
	TaskPropDueDate & 
	TaskPropDescription

export const TASK_STATUS_PROPERTY_NAMES = Object.freeze([TaskProp.Status, TaskProp.Priority, TaskProp.Subject, TaskProp.DueDate, TaskProp.Description])

export type CallTaskStatus = 
	TaskPropStatus & 
	TaskPropPriority & 
	TaskPropSubject & 
	TaskPropStartDate & 
	TaskPropDescription

export const CALL_TASK_STATUS_PROPERTY_NAMES = Object.freeze([TaskProp.Status, TaskProp.Priority, TaskProp.Subject, TaskProp.StartDate, TaskProp.Description])
